<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="группу"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getTaskGroup"
      :get-list="getItems"
      :can-create-catalog="canEditTaskGroup()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <task-group
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import TaskGroup from "./TaskGroup.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "TaskGroupSelect",
  components: { TaskGroup, CatalogSelect },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getTaskGroupsSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getTaskGroup(id) {
      const result = await this.getTaskGroupById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canEditTaskGroup() {
      return this.hasPermission([PERM.CATALOG_TASK_GROUP_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/TaskGroups/TaskGroupSelect.vue